import React from 'react';
import styled from 'styled-components';
import { Col, FlexView, Row } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';
import { RESOLVED_STATUSES, TICKET_STATUS } from '../constants';
import {
  ThreadHeader as HeaderBar,
  ThreadAvatar,
  ThreadTitle,
  ThreadSubTitle,
  ResolveConfirmInline,
  BtnSecondary,
  BtnPrimary,
  SA_COLORS,
} from '../styled-comps';
import Icon from './icon';

// ── Styled components ─────────────────────────────────────────────────

const ThreadTitleArea = styled(Col)`
  && {
    flex: 1;
    min-width: 0;
    gap: 2px;
  }
`;

const ResolveWrap = styled(FlexView)`
  && {
    position: relative;
    flex-shrink: 0;
  }
`;

const ResolveBtn = styled.button`
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 600;
  border: 1px solid ${SA_COLORS.SUCCESS_700};
  background: ${SA_COLORS.SUCCESS_100};
  color: ${SA_COLORS.SUCCESS_700};
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: ${SA_COLORS.SUCCESS_200};
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
    pointer-events: none;
  }
`;

const ConfirmText = styled(Text)`
  && {
    font-size: 13px;
    color: ${SA_COLORS.TEXT_PRIMARY};
    line-height: 1.4;
  }
`;

const ConfirmActions = styled(Row)`
  && {
    gap: 8px;
    justify-content: flex-end;
  }
`;

// ── Component ─────────────────────────────────────────────────────────

const ThreadHeader = ({
  ticketId,
  customerName,
  initials,
  headerLabel,
  perms,
  resolved,
  activeTicket,
  showResolveConfirm,
  setShowResolveConfirm,
  handleResolve,
  resolveProcessing,
}) => (
  <HeaderBar>
    <ThreadAvatar>{initials}</ThreadAvatar>
    <ThreadTitleArea>
      <ThreadTitle>
        <Text variant="caption">Ticket - {ticketId}</Text>
      </ThreadTitle>
      {headerLabel && <ThreadSubTitle>{headerLabel}</ThreadSubTitle>}
    </ThreadTitleArea>
    {perms.can_change_status &&
      (resolved ||
      RESOLVED_STATUSES.includes((activeTicket?.status || '').toUpperCase()) ? (
        <ResolveWrap>
          <ResolveBtn disabled>
            {(activeTicket?.status || TICKET_STATUS.RESOLVED).replace(/_/g, ' ')}
          </ResolveBtn>
        </ResolveWrap>
      ) : (
        <ResolveWrap>
          <ResolveBtn onClick={() => setShowResolveConfirm(v => !v)}>
            <Icon name="check" size={14} /> Mark Resolved
          </ResolveBtn>
          {showResolveConfirm && (
            <ResolveConfirmInline>
              <ConfirmText>
                Resolve this ticket? The customer will be notified.
              </ConfirmText>
              <ConfirmActions>
                <BtnSecondary onClick={() => setShowResolveConfirm(false)}>
                  Cancel
                </BtnSecondary>
                <BtnPrimary onClick={handleResolve} disabled={resolveProcessing}>
                  {resolveProcessing ? 'Resolving...' : 'Resolve'}
                </BtnPrimary>
              </ConfirmActions>
            </ResolveConfirmInline>
          )}
        </ResolveWrap>
      ))}
  </HeaderBar>
);

export default ThreadHeader;
